__turbopack_context__.v({
  "content": "_97FQfW_content",
  "expander-button": "_97FQfW_expander-button",
  "headline": "_97FQfW_headline",
  "placeholder": "_97FQfW_placeholder",
  "section": "_97FQfW_section",
  "section-bg-faded-gray": "_97FQfW_section-bg-faded-gray",
  "section-bg-white": "_97FQfW_section-bg-white",
  "section-pbd-3xl": "_97FQfW_section-pbd-3xl",
  "section-pbd-3xs": "_97FQfW_section-pbd-3xs",
  "section-pbd-l": "_97FQfW_section-pbd-l",
  "section-pbd-m": "_97FQfW_section-pbd-m",
  "section-pbd-none": "_97FQfW_section-pbd-none",
  "section-pbd-s": "_97FQfW_section-pbd-s",
  "section-pbd-xl": "_97FQfW_section-pbd-xl",
  "section-pbd-xs": "_97FQfW_section-pbd-xs",
  "section-pbd-xxl": "_97FQfW_section-pbd-xxl",
  "section-pbd-xxs": "_97FQfW_section-pbd-xxs",
  "section-pbm-3xl": "_97FQfW_section-pbm-3xl",
  "section-pbm-3xs": "_97FQfW_section-pbm-3xs",
  "section-pbm-l": "_97FQfW_section-pbm-l",
  "section-pbm-m": "_97FQfW_section-pbm-m",
  "section-pbm-none": "_97FQfW_section-pbm-none",
  "section-pbm-s": "_97FQfW_section-pbm-s",
  "section-pbm-xl": "_97FQfW_section-pbm-xl",
  "section-pbm-xs": "_97FQfW_section-pbm-xs",
  "section-pbm-xxl": "_97FQfW_section-pbm-xxl",
  "section-pbm-xxs": "_97FQfW_section-pbm-xxs",
  "section-ptd-3xl": "_97FQfW_section-ptd-3xl",
  "section-ptd-3xs": "_97FQfW_section-ptd-3xs",
  "section-ptd-l": "_97FQfW_section-ptd-l",
  "section-ptd-m": "_97FQfW_section-ptd-m",
  "section-ptd-none": "_97FQfW_section-ptd-none",
  "section-ptd-s": "_97FQfW_section-ptd-s",
  "section-ptd-xl": "_97FQfW_section-ptd-xl",
  "section-ptd-xs": "_97FQfW_section-ptd-xs",
  "section-ptd-xxl": "_97FQfW_section-ptd-xxl",
  "section-ptd-xxs": "_97FQfW_section-ptd-xxs",
  "section-ptm-3xl": "_97FQfW_section-ptm-3xl",
  "section-ptm-3xs": "_97FQfW_section-ptm-3xs",
  "section-ptm-l": "_97FQfW_section-ptm-l",
  "section-ptm-m": "_97FQfW_section-ptm-m",
  "section-ptm-none": "_97FQfW_section-ptm-none",
  "section-ptm-s": "_97FQfW_section-ptm-s",
  "section-ptm-xl": "_97FQfW_section-ptm-xl",
  "section-ptm-xs": "_97FQfW_section-ptm-xs",
  "section-ptm-xxl": "_97FQfW_section-ptm-xxl",
  "section-ptm-xxs": "_97FQfW_section-ptm-xxs",
});
